var classof = require('../internals/classof-raw');

module.exports = typeof process != 'undefined' && classof(process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/engine-is-node.js
// module id = 2205
// module chunks = 0